import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GroupSharingLobbyQAComponent } from './group-sharing-lobby-qa/group-sharing-lobby-qa.component';
import { GroupSharingLobbyComponent } from './group-sharing-lobby/group-sharing-lobby.component';
import { GroupSharingComponent } from './group-sharing.component';

const routes: Routes = [
  {
    path: '',
    component: GroupSharingComponent
  },
  {
    path: 'lobby',
    component: GroupSharingLobbyComponent
  },
  {
    path: 'lobby/:groupSharingId',
    component: GroupSharingLobbyComponent
  },
  {
    path: 'qa-lobby/:groupSharingId',
    component: GroupSharingLobbyQAComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GroupSharingRoutingModule { }
